import { Card, Avatar, Stack, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { fontSizes } from "../../../theme/font-sizes";
import { darkColors } from "../../../theme/colors";
import { AvatarWrapper } from "../home/user-profile";
import { assetIcons } from "../../../constants/assets";
import OddsChip from "./chip";

export const StyledCard = styled(Card)(({ theme, isMediumScreen }) => ({
  background: "linear-gradient(to right, #171717, #171717)",
  color: "white",
  padding: theme.spacing(2.5),
  minWidth: isMediumScreen ? 130 : "300px",
  display: isMediumScreen ? "flex-col" : "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "12px",
  margin: theme.spacing(0, 1),
}));

export const OddsCard = ({
  username,
  bettors,
  odds,
  avatar,
  isMediumScreen,
  onClick,
}) => (
  <StyledCard onClick={onClick} isMediumScreen={isMediumScreen}>
    <Stack
      direction={isMediumScreen ? "column" : "row"}
      spacing={1}
      alignItems={isMediumScreen ? "start" : "center"}
    >
      <AvatarWrapper>
        <Avatar
          src={avatar}
          // alt="loading..."
          sx={{
            width: 34,
            height: 34,
            border: "2px solid",
            borderColor: darkColors.buttonTop,
          }}
        />
      </AvatarWrapper>
      <Stack>
        <Typography
          textAlign="left"
          fontSize={fontSizes.heading3}
          fontWeight={600}
          mt={isMediumScreen ? 0.7 : 0}
        >
          {username}
        </Typography>
        <Typography
          textAlign="left"
          fontSize={fontSizes.body}
          color={darkColors.lightGray}
          mt={isMediumScreen ? 1 : 0}
        >
          {bettors} Bets
        </Typography>
      </Stack>
    </Stack>
    <OddsChip odds={odds} isMediumScreen={isMediumScreen} />
  </StyledCard>
);
